import { render, staticRenderFns } from "./StaffBlock.vue?vue&type=template&id=f5573d4e"
import script from "./StaffBlock.vue?vue&type=script&lang=ts"
export * from "./StaffBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports